import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import QuoteCalculator from "@/components/site/QuoteCalculator";
import BookingSection from "@/components/site/BookingSection";
import About from "@/components/site/About";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import ServiceAreas from "@/components/site/ServiceAreas";
import FAQ from "@/components/site/FAQ";
import Marquee from "@/components/site/Marquee";
import TrustBar from "@/components/site/TrustBar";
import HowItWorks from "@/components/site/HowItWorks";
import StickyMobileCTA from "@/components/site/StickyMobileCTA";
import MusicPlayer from "@/components/site/MusicPlayer";
import VideoShowcase from "@/components/site/VideoShowcase";
import PopularRoutes from "@/components/site/PopularRoutes";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#F5F3EC]" data-testid="home-page">
      <Header />
      <main className="pb-14 lg:pb-0">
        <Hero />
        <VideoShowcase />
        <TrustBar />
        <Marquee />
        <Services />
        <QuoteCalculator />
        <PopularRoutes />
        <HowItWorks />
        <About />
        <Gallery />
        <BookingSection />
        <Testimonials />
        <ServiceAreas />
        <FAQ />
      </main>
      <Footer />
      <StickyMobileCTA />
      <MusicPlayer />
    </div>
  );
}
